import * as React from 'react';
import { useContext, createContext } from 'react';
import LanguageDto from '../models/LanguageDto';
import { useTranslation } from 'react-i18next';
import { fromString } from '../enum/Language';
import { useSessionStorageState } from '../hooks/useSessionStorageState';

let initialState: LanguageDto = LanguageDto.prototype;

interface LanguageContextInterface {
  language: LanguageDto,
  setLanguage: (newLanguage: LanguageDto) => void,
}

const LanguageContext = createContext<LanguageContextInterface>({ language: initialState, setLanguage: () => { } });

export const useLanguage = () => useContext(LanguageContext);

const userLocale = window.navigator.languages[0] || window.navigator.language;

export function LanguageProvider(props: React.PropsWithChildren<{}>) {
  const { i18n } = useTranslation();
  const [changedLanguage, setChangedLanguage] = useSessionStorageState<boolean>('qr-menu.changedLanguage', false);
  if (changedLanguage || userLocale.split('-')[0].toLowerCase() === i18n.language.toLowerCase()) {
    initialState = { ...initialState, language: fromString(i18n.language) };
  }
  const [language, setLanguageState] = React.useState(initialState);
  const setLanguage = (language: LanguageDto) => {
    setChangedLanguage(true);
    setLanguageState(language);
    i18n.changeLanguage(language?.language?.toLowerCase());
  }
  const value = { language, setLanguage };

  return <LanguageContext.Provider value={value} {...props} />;
}
